// extracted by mini-css-extract-plugin
export default {"error":"UploadFileError_error__HNsvf"};